import { hero } from './hero';
import { carousel } from './carousel';
import './features';
import './header';
import './sidebar';
import './sidebar-menu';
import './modules/photoswipe.module';
import './shariff';
import { $, $$ } from './lib/$.module';

hero($$('.ce-mask_hero'))
let carousels = carousel($$('.ce-mask_carousel .splide'), {
    type: 'loop',
    speed: 500,
    width: '100%',
    fixedWidth: 'var(--carousel-width)',
    gap: 'var(--carousel-gap)',
    // rewindSpeed: 1500,
    rewind: false,
    keyboard: true,
    wheel: false,
    perPage: 3,
    perMove: 1,
    focus: 'center',
    trimSpace: true,
    updateOnMove: true,
    cloneStatus: true,
    flickMaxPages: 1,
    // isNavigation: true,
    arrowPath: 'M39.2,22c1.1-1.1,1.1-2.9,0-4L24.9,3.7c-1.1-1.1-2.9-1.1-4,0c-1.1,1.1-1.1,2.9,0,4l9.4,9.4H2.9C1.3,17.1,0,18.4,0,20c0,1.6,1.3,2.9,2.9,2.9h27.4l-9.4,9.4c-1.1,1.1-1.1,2.9,0,4c1.1,1.1,2.9,1.1,4,0L39.2,22L39.2,22z',
})
